// LocalStorage cache helper for calendar data

const CALENDAR_CACHE_KEY = 'own_calendar_cache';
const OTHER_USER_CALENDAR_CACHE_KEY = (userId) => `other_user_calendar_cache_${userId}`;

/**
 * Save calendar data to localStorage
 * @param {object} data - Calendar data with metadata
 * @param {string} data.data - Calendar data object
 * @param {string} data.range_start - Earliest date in cache
 * @param {string} data.range_end - Latest date in cache
 */
export function saveCalendarDataToCache(data) {
  try {
    localStorage.setItem(CALENDAR_CACHE_KEY, JSON.stringify(data));
  } catch (err) {
  }
}

/**
 * Load calendar data from localStorage
 * @returns {object|null} Cached calendar data with metadata, or null if not found
 */
export function loadCalendarDataFromCache() {
  try {
    const cached = localStorage.getItem(CALENDAR_CACHE_KEY);
    return cached ? JSON.parse(cached) : null;
  } catch (err) {
    return null;
  }
}

/**
 * Clear calendar data from localStorage
 */
export function clearCalendarDataCache() {
  try {
    localStorage.removeItem(CALENDAR_CACHE_KEY);
  } catch (err) {
  }
}

/**
 * Save other user's calendar data to localStorage
 * @param {string} userId - The user ID to cache data for
 * @param {object} data - Calendar data with metadata
 * @param {string} data.data - Calendar data object
 * @param {string} data.range_start - Earliest date in cache
 * @param {string} data.range_end - Latest date in cache
 */
export function saveOtherUserCalendarDataToCache(userId, data) {
  try {
    localStorage.setItem(OTHER_USER_CALENDAR_CACHE_KEY(userId), JSON.stringify(data));
  } catch (err) {
  }
}

/**
 * Load other user's calendar data from localStorage
 * @param {string} userId - The user ID to load data for
 * @returns {object|null} Cached calendar data with metadata, or null if not found
 */
export function loadOtherUserCalendarDataFromCache(userId) {
  try {
    const cached = localStorage.getItem(OTHER_USER_CALENDAR_CACHE_KEY(userId));
    return cached ? JSON.parse(cached) : null;
  } catch (err) {
    return null;
  }
}

/**
 * Clear other user's calendar data from localStorage
 * @param {string} userId - The user ID to clear data for
 */
export function clearOtherUserCalendarDataCache(userId) {
  try {
    localStorage.removeItem(OTHER_USER_CALENDAR_CACHE_KEY(userId));
  } catch (err) {
  }
}
